/**
 * 铃铛徽章未读数 hook（需求9 · AC-PAGE-MCH-NTF-001-08 / AC-NTF-002 · D3 口径）
 *
 * - 徽章 = unread-count 接口 unreadCount（未读待办 + 未读告警 + 未读消息，全类型动态计数，禁写死）
 * - 为 0 / 接口失败 → 返回 null（调用方隐藏数字，不渲染「0」气泡、不显示错误数字）
 * - 刷新策略（契约 §4.2 风险 3 最小策略）：进入应用拉取 + 页内操作后经
 *   notifyNoticeBadgeChanged() 事件刷新；定时轮询为可选增强，本期不做硬依赖
 */
import { useCallback, useEffect, useState } from 'react';
import { fetchNoticeUnreadCount } from '@/api/notices';

/** 页内已读操作后广播的徽章刷新事件名（Header 与 Sidebar 共用） */
export const NOTICE_BADGE_EVENT = 'allinks-merchant-notice-badge';

/** 页内已读操作后调用：触发所有徽章消费方重拉 unread-count（本地即时刷新，无需等轮询） */
export function notifyNoticeBadgeChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(NOTICE_BADGE_EVENT));
  }
}

/** 铃铛徽章未读数：数字不可信（接口失败 / 未加载）时为 null，调用方隐藏徽章 */
export function useUnreadNoticeCount(): number | null {
  const [count, setCount] = useState<number | null>(null);

  const load = useCallback(async () => {
    const res = await fetchNoticeUnreadCount();
    // 失败 → null（隐藏数字）；成功但 0 → 仍返回 0，由调用方决定隐藏
    setCount(res.ok ? res.data.unreadCount : null);
  }, []);

  useEffect(() => {
    void load();
    const onChange = () => void load();
    window.addEventListener(NOTICE_BADGE_EVENT, onChange);
    return () => window.removeEventListener(NOTICE_BADGE_EVENT, onChange);
  }, [load]);

  return count;
}
